import Joi from 'joi';
import _ from 'lodash';

export function getValues (obj) {
    let values = obj.toJS();
    if (typeof obj.getComputedValues === 'function') {
        Object.assign(values, obj.getComputedValues());
    }
    return values;
}

function cleanErrorMessage (message) {
    // Joi adds "someFieldName" at the start - we strip it out
    return _.isString(message) ? message.replace(/^"[\S]+"\s/, '') : message;
}

const ValidationMixin = {
    isComplete () {
        const schemaData = getValues(this);
        return !this.validateData(schemaData, this.getSchema());
    },

    isFieldValid (field, additionalValues, additionalSchemaFields) {
        const { error } = this.validateField(field, additionalValues, additionalSchemaFields); // you may want to override the stored value to check an arbitrary value against the field's schema

        return !error;
    },

    validate () {
        return Joi.object(this.getSchema()).validate(getValues(this), { abortEarly: false, allowUnknown: true });
    },

    validateField (field, additionalValues = {}, additionalSchemaFields = []) {
        const values = this.toJS();

        if (values && typeof values[field] !== 'undefined') {
            const schema = Object.assign(...[field, ...additionalSchemaFields].map(name => ({ [name]: this.getSchema()[name] })));

            return Joi.object(schema).validate({
                [field]: values[field],
                ...additionalValues
            }, { allowUnknown: true });
        } else {
            throw `The validateField failed because "${field}" does not exist in the Record: ${JSON.stringify(values, null, 2)}.`;
        }
    },

    getValidationSummary () {
        const values = getValues(this);
        const fields = _.zipObject(_.keys(values));
        const errors = this.validateData(values, this.getSchema(), { abortEarly: false });
        const errorDetails = errors ? errors.details : [];

        return errorDetails.reduce((acc, detail) => {
            acc[detail.path.join('.')] = cleanErrorMessage(detail.message);
            return acc;
        }, fields);
    },

    getValidationSummaryArray () {
        return _.compact(_.values(this.getValidationSummary()));
    },

    getError (field) {
        return this.getValidationSummary()[field];
    },

    validateData (value, schema, options) {
        options = Object.assign({ allowUnknown: true }, options);
        const { error } = Joi.object(schema).validate(value, options);
        return error;
    }
};

export default ValidationMixin;
